export class Tienda {

    constructor(

      public id?: number,
      public nombre?: string,
      public direccion?: string,
      public telefono?: string,
      public movil?: string,
      public correo?: string,
      public web?: string,
      public logo?: string,
      public regimen?: string,
    ) {
    }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/tienda/tienda.ts